import { isEmpty } from 'lodash';
import { getUserData, getWorkspace, store } from '@zonofi/zono-money-store';

type LoggedInUserType = 'principal' | 'distributor' | 'sales';

export const useGetLoggedInUserType = (): LoggedInUserType => {
  const userData = getUserData(store.getState());
  const workspaceData = getWorkspace(store.getState());

  if (userData.inviteUserType === 'Sales') {
    return 'sales';
  }
  if (isEmpty(workspaceData)) return 'principal';

  return workspaceData.isSeller ? 'principal' : 'distributor';
};
